<template>
    <svg class="w-5 h-5" width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M1 0.75L10.5 10.25L20 0.749999" stroke="url(#paint0_linear_301_559)" stroke-width="2"/>
        <defs>
            <linearGradient id="paint0_linear_301_559" x1="4.8" y1="2.175" x2="8.60211" y2="12.2777" gradientUnits="userSpaceOnUse">
                <stop stop-color="#C744FF"/>
                <stop offset="1" stop-color="#007BC2"/>
            </linearGradient>
        </defs>
    </svg>
</template>